import { useColorModeValue } from "@chakra-ui/react"

const useColorTheme = () => {
  const gray = useColorModeValue("gray.100", "gray.700")
  const textColor = useColorModeValue("blue.900", "white.900")
  const secondaryTextColor = useColorModeValue("gray.600", "gray.400")

  return {
    gray,
    textColor,
    secondaryTextColor,
  } as const
}

export default useColorTheme
